// src/components/assets/EditAssetModal.tsx
import React, { useCallback } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  Typography
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { useAsset } from "../../context/AssetContext";
import UploadAsset from "./UploadAsset";

const EditAssetModal: React.FC = () => {
  const {
    asset,
    isEditAssetModalOpen, // Get the new state from the context
    closeEditAssetModal,  // Get the new close function
  } = useAsset();

  if (!asset) return <></>

  return (
    <Dialog open={isEditAssetModalOpen} onClose={closeEditAssetModal} fullWidth maxWidth="lg">
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">Asset Media Manager</Typography>
          <IconButton onClick={closeEditAssetModal} aria-label="close">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent sx={{ pt: 1 }}>
        <UploadAsset key={asset.pk} />
      </DialogContent>
    </Dialog>
  );
};

export default EditAssetModal;